export class Profile {
  student_type?: string;
  currently_enrolled?: boolean = false;
  currently_enrolled_college?: any = null;
  currently_enrolled_other_college_name?: string = '';
  current_college_name?: string;
  gpa?: number | string | null;
  date_of_birth?: Date | string | null;
  term_id?: number;
  term_name?: string;

  constructor(profile: any) {
    _.merge(this, profile);
  }

  static build(profile: any) {
    return new Profile(profile);
  }
}

angular.module('capability-ng-admin-authentication').factory('ngProfileBuilder', (): typeof Profile => Profile);



// WEBPACK FOOTER //
// ./app/lib/authentication/builders/profile_builder.ts